import nros_js from 'nr.os.js'

const nros = new nros_js()
nros.getPlugin('http').setBaseURL(nros.getPlugin('config').getConfig().baseUrl)

if (!nros.getPlugin("login").getToken()) {
    nros.getPlugin("login").load(nros.getPlugin('config').getConfig().storageMode)
    Object.keys(nros.getPlugin('login').getHeader()).forEach((item) => {
        nros.getPlugin('http').setHeader(item, nros.getPlugin('login').getHeader()[item])
    })
}

nros.getPlugin('event').on('set-user-success', () => {
    const lang = nros.getPlugin('resource').getCurrLanguage() || 'zh-CN'
    nros.getPlugin('http').setHeader('language', lang)
})

window._core = nros
window.osConfig = nros.getPlugin('config').getConfig()
export default nros



// WEBPACK FOOTER //
// ./src/common/nros.js